import type { Flags } from '~/constants/featureFlags';

function redirectUnauthorized() {
  return navigateTo('/access-denied');
}

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return undefined;
  }

  const requiredFlag = to.meta.requiredFeatureFlag as Flags | undefined;

  if (!requiredFlag) {
    return undefined;
  }

  if (!useFlag(requiredFlag).value) {
    return redirectUnauthorized();
  }

  return undefined;
});
